import React from 'react';
import {Trans} from 'react-i18next';
import {useNavigate} from 'react-router';
import {diApi} from '@di-shared/api/di';
import Header from '@di-shared/features/common/Header';
import HeaderCloseButton from '@di-shared/features/common/HeaderCloseButton';
import useCcWebviewUtilsHelper from '@di-shared/features/common/useCcWebviewUtilsHelper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {ROUTE_PATHS} from '@di-shared/routes';
import {subDate} from '@shared/dateUtils';
import {getQueryKey} from '@shared/queryKeyMap';
import {useSuspenseQuery} from '@tanstack/react-query';

interface MileageParticipationGuideProps {
  vin: string;
}

function MileageParticipationGuide({vin}: MileageParticipationGuideProps) {
  const navigate = useNavigate();
  const {backOrClose} = useCcWebviewUtilsHelper();
  const {t} = useInferableTranslation();

  const {data: mileageHistory} = useSuspenseQuery({
    queryKey: [getQueryKey(diApi.ecoMileageController.getInfoMileage), vin],
    queryFn: () => diApi.ecoMileageController.getInfoMileage({vin}),
    select: (data) => data.data.rtn_data.PYMNT_INFO,
  });

  return (
    <div className="wrap">
      <Header right={<HeaderCloseButton onClick={() => backOrClose()} />}>
        <h1 className="headline_xxsmall nav_center_title">{t('T10122')}</h1>
      </Header>
      <main className="content page_eco_mileage">
        <section className="section section_mileage_submit">
          <div className="section_heading type_main">
            <h2 className="section_heading_title">{t('T10349')}</h2>
            <p className="section_heading_desc">{t('T10350')}</p>
          </div>
        </section>
      </main>
      <div className="floating_action_area">
        <div className="floating_guide_box">
          <div className="floating_guide_icon">
            <span className="ic ic_warning_24px" />
          </div>
          <span className="floating_guide_text">{t('T10351')}</span>
        </div>
        {/* 지급 정보 상세 리스트(rtn_data.PYMNT_INFO) 존재 유무로 '적립 내역 확인' 버튼 노출 */}
        {mileageHistory.length > 0 && (
          <button
            type="button"
            className="btn btn_large btn_filled btn_full"
            onClick={() => navigate(`${ROUTE_PATHS.MILEAGE_BALANCE.getFullPath(vin)}?hideTab=eco|safe`)}
          >
            {t('T10352')}
          </button>
        )}
      </div>
    </div>
  );
}

export default MileageParticipationGuide;
